import { MenuObjectTypes } from 'enums/menu';
import { IIngredients } from 'generated/sanity-graphql';

import { IUseNutritionFactsProps, NutritionFacts } from './types';
import { emptyNutritionFacts, getAllergenGroups } from './utils';

type UseNutritionFacts = (props: IUseNutritionFactsProps) => NutritionFacts[];

export const useNutritionFacts: UseNutritionFacts = ({
  pickerSelection,
  comboSlotSelections = {},
  itemName,
  itemImage,
}) => {
  const nutritionFacts = [] as NutritionFacts[];

  if (pickerSelection._type === MenuObjectTypes.COMBO) {
    const { mainItem } = pickerSelection;

    if (mainItem) {
      nutritionFacts.push({
        itemName: mainItem.name?.locale,
        itemImage: mainItem.image,
        facts: mainItem.nutritionWithModifiers,
        allergenGroups: mainItem.allergens ? getAllergenGroups(mainItem.allergens) : [],
        ingredients: (mainItem?.ingredients as unknown) as IIngredients[],
      });
    }

    Object.values(comboSlotSelections)
      // filter out combo sides/NCR combo sides/anything else we have decided not to show
      .filter(selection => selection.data?.uiPattern !== 'hidden')
      .forEach(({ selections }) => {
        const data = selections.map(({ option: { option } }) => ({
          itemName: option.name.locale,
          itemImage: option.image,
          facts: option.nutritionWithModifiers || emptyNutritionFacts,
          allergenGroups: option.allergens ? getAllergenGroups(option.allergens) : [],
          ingredients: (option?.ingredients as unknown) as IIngredients[],
        }));

        nutritionFacts.push(...data);
      });
  } else {
    nutritionFacts.push({
      itemName,
      itemImage,
      facts: pickerSelection.nutritionWithModifiers,
      allergenGroups: pickerSelection.allergens ? getAllergenGroups(pickerSelection.allergens) : [],
      ingredients: (pickerSelection?.ingredients as unknown) as IIngredients[],
    });
  }

  return nutritionFacts;
};
